import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

export enum BootstrapIcon {
  default = "bi bi-dash",
  dashboard = "bi bi-house-fill",
  users = "bi bi-person-check-fill",
  knowledgebase = "bi bi-lightbulb-fill",
  standstill = "bi bi-exclamation-diamond-fill",
  escalation = "bi bi-x-octagon-fill",
  workplaces = "bi bi-wrench-adjustable-circle",
  workstations = "bi bi-hammer",
  productionLines = "bi bi-gear-wide-connected",
  edit = "bi bi-pencil",
  delete = "bi bi-trash",
  plus = "bi bi-plus",
  chevron_right = "bi bi-chevron-right",
  chevron_left = "bi bi-chevron-left",
  back_arrow = "bi bi-arrow-left-short",
  filter = "bi bi-filter-right",
  search = "bi bi-search",
  pie_chart = "bi bi-pie-chart",
  dailyDashboard = "bi bi-calendar-event",
  weeklyDashboard = "bi bi-calendar-week",
  ai = "bi bi-cpu"
}

interface HeaderIcon {
  icon: BootstrapIcon | string;
  color: string;
}

@Injectable({
  providedIn: "root",
})
export class HeaderService {
  private DEFAULT_ICON_COLOR_CLASS = 'text-qundis-primary'
  private headerTitle = new BehaviorSubject<string>("Default Title");
  private headerSubTitle = new BehaviorSubject<string>("Default Sub Title");
  private headerIcon = new BehaviorSubject<HeaderIcon>(
    {icon: BootstrapIcon.default, color: this.DEFAULT_ICON_COLOR_CLASS}
  );
  private backgroundColor = new BehaviorSubject<string>(
    "rgba(255, 255, 255, 100%)"
  );
  private headerSubTitleClickable = new BehaviorSubject<boolean>(false);

  headerTitle$ = this.headerTitle.asObservable();
  backgroundColor$ = this.backgroundColor.asObservable();
  headerSubTitle$ = this.headerSubTitle.asObservable();
  headerIcon$ = this.headerIcon.asObservable();
  headerSubTitleClickable$ = this.headerSubTitleClickable.asObservable();

  setHeaderTitle(title: string) {
    this.headerTitle.next(title);
  }

  setBackgroundColor(color: string) {
    this.backgroundColor.next(color);
  }

  setHeaderSubTitle(subTitle: string) {
    this.headerSubTitle.next(subTitle);
  }

  setHeaderIcon(icon: BootstrapIcon | string, color: string = this.DEFAULT_ICON_COLOR_CLASS) {
    this.headerIcon.next({icon, color});
  }

  setIsHeaderClickable(clickable: boolean) {
    this.headerSubTitleClickable.next(clickable);
  }
}
